<i18n src="@/locales/views/authentication/login.yml" lang="yaml"></i18n>
<template>
  <div
    class="body-login min-h-full flex flex-col h-screen w-screen justify-center py-12 sm:px-6 lg:px-8"
  >
    <div
      class="mt-8 sm:mx-auto sm:w-full sm:max-w-md space-y-8"
      @keyup.enter="authenticate()"
    >
      <div
        class="bg-white bg-opacity-0 sm:bg-opacity-100 py-6 px-4 sm:shadow-lg sm:rounded-lg sm:px-10"
      >
        <div class="h-20 rounded-md px-4 py-2 flex justify-center">
          <img
            :src="clientLogo()"
            :alt="clientCode()"
            class="h-16"
            @error="clientLogoError"
          />
        </div>
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
          <h2
            class="mt-6 text-center text-2xl font-bold text-white sm:text-gray-600"
          >
            {{ $t("labels.title") }}
          </h2>
          <alert-danger class="mt-4" :errors_data="std_err" />
        </div>

        <form @submit.prevent="authenticate" class="mt-6 space-y-6">
          <div class="rounded-md shadow-sm -space-y-px">
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <i class="text-gray-400 fa-solid fa-user" aria-hidden="true" />
              </div>
              <input
                v-model="user_id"
                class="appearance-none rounded-none block w-full px-3 py-2 pl-10 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-lime-500 focus:border-lime-500 focus:z-10 sm:text-sm"
                :placeholder="$t('labels.user_id')"
                autofocus
              />
            </div>
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <i
                  class="text-gray-400 fa-solid fa-unlock"
                  aria-hidden="true"
                />
              </div>
              <input
                v-model="password"
                type="password"
                class="appearance-none rounded-none block w-full px-3 py-2 pl-10 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-lime-500 focus:border-lime-500 focus:z-10 sm:text-sm"
                :placeholder="$t('labels.password')"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              v-if="!proc_login_button"
              class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-lime-600 hover:bg-lime-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500"
            >
              {{ $t("labels.login_button") }}
            </button>
            <button
              type="submit"
              v-else
              class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-lime-600 opacity-50"
            >
              <i class="fa-solid fa-sync fa-spin mt-1" />
              <span class="space-icon" />
              {{ $t("labels.login_button") }}
            </button>
          </div>

          <div class="text-center text-sm mt-6">
            <a
              href="#"
              class="font-medium text-white underline sm:text-lime-600 hover:text-lime-500"
            >
              {{ $t("labels.forgot_pass") }}
            </a>
          </div>

          <div
            v-if="displayPoweredBy"
            class="flex justify-center sm:justify-end"
          >
            <div class="p-2 rounded-md">
              <div><i class="text-white sm:text-gray-500">Powered by</i></div>
              <div>
                <img
                  class="w-20"
                  :src="poweredBy()"
                  alt="AgroTec"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import RequesterAuthentication from "./requesters/authentication.js";

export default {
  name: "AuthenticationLogin",
  data: function () {
    return {
      proc_login_button: false,
      user_id: null,
      password: null,
    };
  },
  computed: {
    domain: function () {
      return window.location.hostname;
    },

    displayPoweredBy: function () {
      return this.clientCode() != 'app' && !this.domain.includes('agestor.digital');
    }
  },
  methods: {
    authenticate: async function () {
      this.proc_login_button = true;
      try {
        let response = await RequesterAuthentication.authenticate(
          this.user_id,
          this.password
        );
        this.$store.commit("authentication/login", response.data.user_id);
        this.$store.commit("user/set_full_name", response.data.name);
        this.$store.commit("user/set_entity_types", response.data.entity_types);
        this.setLanguage(response.data.language);
        if (response.data.require_change_password) {
          this.$router.push({ name: "up_change_data_edit_password_path" });
        } else {
          this.$router.push({ name: "home_path" });
        }
      } catch (error) {
        if (error.response.status == 401) {
          this.user_id = null;
          this.password = null;
          this.loadStandardErrorMessages({
            title: "Usuario y/o contraseña incorrectos",
          });
        }
        this.proc_login_button = false;
      }
    },

    setLanguage: async function (language) {
      const language_code = language?.code;
      if (language_code) {
        this.$store.commit("user/set_language", language_code);
        this.$root.$i18n.locale = language_code.split("-")[0];
      }
    },

    poweredBy: function () {
      if (this.domain.includes('ag-sol.lat')) {
        return 'https://agrotecchain.s3.amazonaws.com/images_logos/agricultural-solutions.png';
      }

      return 'https://agrotecchain.s3.amazonaws.com/images_logos/app.png';
    },
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push({ name: "home_path" });
    }
  },
};
</script>
